import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

interface FeatureFlags {
  [id: string]: boolean;
}

export interface IFeatureFlagsService {
  loadFeatureFlags(): void;

  getFeatureFlag(key: Features): boolean;
}

export enum Features {
  Collab = 'COLLAB',
}

@Injectable()
export class FeatureFlagsService implements IFeatureFlagsService {
  featureFlags: FeatureFlags;
  apiUrl: string = '/api/features/';

  constructor(public httpClient: HttpClient) {}

  loadFeatureFlags() {
    this.httpClient.get<FeatureFlags>(this.apiUrl).subscribe(response => (this.featureFlags = response));
  }

  getFeatureFlag(key: Features): boolean {
    return this.featureFlags[key];
  }
}
